import { watch } from "vue";
import { getAngle } from "./Power_WB_getAngle";
import Toast from "@/utils/toast";





export function barWatcher(params_geometry, params_bar, params_bolt, cover) {
  let [R, R1, R2, H1, H2, H3] = params_geometry.slice(0, 6);
  let [
    bar_1,
    bar_1a,
    bar_1b,
    bar_1c,
    bar_2,
    bar_2a,
    bar_3,
    bar_4,
    // bar_4a,
    // bar_4b,
    bar_5,
    // bar_5a,
    // bar_5b,
    bar_6,
    bar_7,
    bar_7a,
    bar_8,
    bar_9,
    bar_10,
    bar_11,
    bar_12,
    bar_13,
    bar_14,
    bar_15,
    bar_15a,
    bar_16,
    bar_17,
    bar_18,
  ] = params_bar.filter((item) => item.No !== "04a" && item.No !== "04b" && item.No !== "05a" && item.No !== "05b");
  let Br_in = params_bolt.find((obj) => obj.name === "Br_in");
  let Br_out = params_bolt.find((obj) => obj.name === "Br_out");
  let Bnum_in = params_bolt.find((obj) => obj.name === "Bnum_in");
  let [cover_btm, cover_other] = cover;

  // Watch for a of 1~2a
  watch(H1, (newValue) => {
    bar_1.data.data_a.value =
      bar_1a.data.data_a.value =
      bar_2.data.data_a.value =
      bar_2a.data.data_a.value =
      Math.max((newValue.value * 1000) / 2 + 100, 600);
  });

  // Watch for b of 1   b c of 1a
  watch(
    [
      Br_in,
      R,
      R2,
      bar_1.diameter,
      bar_1a.diameter,
      bar_3.diameter,
      bar_4,
      cover_other,
      Br_out,
    ],
    (newValue) => {
      let b1 = Math.max(
        33 * newValue[3].value,
        newValue[2].value * 1000 - newValue[0].value + 500
      );
      let b2 =
        newValue[1].value * 1000 -
        newValue[2].value * 1000 -
        newValue[7].value -
        newValue[5].value -
        newValue[3].value / 2;
      // 1
      if (parseFloat(newValue[6].data.data_e.value) == 0) {
        bar_1.data.data_b.value = Math.ceil((b1 + b2) / 100) * 100;
      } else if (parseFloat(newValue[6].data.data_e.value) <= 3) {
        bar_1.data.data_b.value =
          Math.ceil(
            (Math.max(
              33 * newValue[3].value,
              newValue[2].value * 1000 - newValue[0].value + 500
            ) +
              b2) /
            50
          ) * 50;
      } else {
        bar_1.data.data_b.value =
          Math.ceil(
            (Math.max(
              33 * newValue[3].value,
              newValue[2].value * 1000 - newValue[6].data.data_d.value + 50
            ) +
              b2) /
            50
          ) * 50;
      }
      // 1a
      bar_1a.data.data_b.value =
        Math.floor(
          (Math.max(
            18 * newValue[4].value,
            newValue[2].value * 1000 - newValue[8].value + 100
          ) +
            b2) /
          50
        ) * 50;
      bar_1a.data.data_c.value =
        Math.ceil((12 * newValue[4].value) / 100) * 100;
    }
  );

  // 1和1a的间距和锚固长度检查~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // watch(
  //   [
  //     R,
  //     R2,
  //     cover_other,
  //     bar_1.data.data_b,
  //     bar_1a.data.data_b,
  //     bar_1.diameter,
  //     bar_1a.diameter,
  //     bar_3.diameter,
  //     bar_1.num,
  //     bar_1a.num,
  //   ],
  //   (newValue) => {
  //     let r1 = parseFloat(
  //       newValue[0].value * 1000 -
  //       newValue[2].value -
  //       newValue[7].value -
  //       newValue[3].value -
  //       newValue[5].value / 2
  //     );
  //     if (
  //       (r1 * 2 * 3.1415) / parseFloat(newValue[8].value) <
  //       Math.max(2 * newValue[5].value, 25 + newValue[5].value)
  //     ) {
  //       alert("1号钢筋内端点处间距过小， 请修改输入值");
  //     }
  //     if (
  //       parseFloat(newValue[1].value) * 1000 - r1 <
  //       33 * parseFloat(newValue[5].value)
  //     ) {
  //       alert("1号钢筋锚固长度不足， 请增大b的值或，同时增大b和R2的值");
  //     }

  //     let r1a = parseFloat(
  //       newValue[0].value * 1000 -
  //       newValue[2].value -
  //       newValue[7].value -
  //       newValue[4].value -
  //       newValue[6].value / 2
  //     );
  //     if (
  //       (r1a * 2 * 3.1415) / parseFloat(newValue[8].value + newValue[9].value) <
  //       Math.max(
  //         (2 * (newValue[6].value + newValue[5].value)) / 2,
  //         25 + (newValue[6].value + newValue[5].value) / 2
  //       )
  //     ) {
  //       alert("1a号钢筋内端点处间距过小， 请修改输入值");
  //     }
  //     if (
  //       parseFloat(newValue[1].value) * 1000 - r1a <
  //       18 * parseFloat(newValue[6].value)
  //     ) {
  //       alert("1a号钢筋锚固长度不足， 请增大b的值或，同时增大b和R2的值");
  //     }
  //   }
  // );
  // 间距和锚固长度检查~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  // Watch for 1b
  watch([bar_1b.diameter, bar_1b.data.data_set], (newValue) => {

    if (newValue[1].value == 0) {
      bar_1b.diameter.status = true;
      bar_1b.data.data_a.status = true;
      bar_1b.data.data_b.status = true;
      bar_1b.data.data_a.value = 0;
      bar_1b.data.data_b.value = 0;
    } else {
      bar_1b.diameter.status = false;
      bar_1b.data.data_a.status = false;
      bar_1b.data.data_b.status = false;
      bar_1b.data.data_a.value =
        Math.ceil((12 * newValue[0].value) / 100) * 100;
      bar_1b.data.data_b.value =
        Math.ceil((R.value * 1000 - R2.value * 1000) / 2 / 100) * 100;
    }
  });



  // Watch for b c of 2,  b c d of 2a
  watch(
    [
      R,
      R1,
      R2,
      H2,
      bar_2.diameter,
      bar_2a.diameter,
      Br_out,
      Br_in,
      bar_3.diameter,
      bar_5.diameter,
      cover_other,
    ],
    (newValue) => {
      let param = getAngle(
        newValue[0],
        newValue[1],
        newValue[2],
        newValue[4],
        newValue[8],
        newValue[9],
        newValue[10]
      );
      let a = param[0]; //角点与斜边的夹角
      let x = param[2]; //角点垂直于斜边的距离
      let tem_b = Math.sqrt(
        Math.pow(newValue[0].value * 1000 - newValue[1].value * 1000, 2) +
        Math.pow(newValue[3].value * 1000, 2)
      );
      bar_2.data.data_b.value = Math.ceil((tem_b - x / Math.tan(a)) / 50) * 50;
      bar_2a.data.data_b.value = Math.ceil((tem_b - x / Math.tan(a)) / 50) * 50;

      bar_2.data.data_c.value =
        Math.ceil(
          Math.max(
            33 * newValue[4].value,
            newValue[1].value * 1000 - newValue[7].value + 300
          ) / 50
        ) * 50;
      bar_2a.data.data_c.value =
        Math.floor(
          (Math.max(18 * newValue[5].value, 1000) +
            (newValue[1].value * 1000 - newValue[2].value * 1000)) /
          50
        ) * 50;

      bar_2a.data.data_d.value = Math.ceil((12 * newValue[5].value) / 50) * 50;
    }
  );

  // // 2和2a的间距和锚固长度检查~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // watch(
  //   [
  //     bar_2.data.data_c,
  //     bar_2a.data.data_c,
  //     bar_2.diameter,
  //     bar_2a.diameter,
  //     bar_2.num,
  //     bar_2a.num,
  //     R1,  //6
  //     R2,  //7
  //   ],
  //   (newValue) => {
  //     if (
  //       ((parseFloat(newValue[6].value) * 1000 - parseFloat(newValue[0].value)) *
  //         2 *
  //         3.1415) /
  //       parseFloat(newValue[4].value) <
  //       Math.max(2.5 * newValue[2].value, 30 + newValue[2].value)
  //     ) {
  //       alert("2号钢筋内端点处间距过小， 请修改输入值");
  //     }
  //     if (
  //       parseFloat(newValue[7].value) * 1000 -
  //       (parseFloat(newValue[6].value) * 1000 - parseFloat(newValue[0].value)) <
  //       33 * parseFloat(newValue[2].value)
  //     ) {
  //       alert("2号钢筋锚固长度不足， 请增大c的值或，同时增大c和R2的值");
  //     }

  //     if (
  //       ((parseFloat(newValue[6].value) * 1000 - parseFloat(newValue[1].value)) *
  //         2 *
  //         3.1415) /
  //       parseFloat(newValue[4].value + newValue[5].value)
  //       <
  //       Math.max(
  //         (2.5 *
  //           (parseFloat(newValue[2].value) + parseFloat(newValue[3].value))) /
  //         2,
  //         30 +
  //         (parseFloat(newValue[2].value) + parseFloat(newValue[3].value)) / 2
  //       )
  //     ) {
  //       alert("2a号钢筋内端点处间距过小， 请修改输入值");
  //     }
  //     if (
  //       parseFloat(newValue[7].value) * 1000 -
  //       (parseFloat(newValue[6].value) * 1000 - parseFloat(newValue[1].value)) <
  //       (33 * (parseFloat(newValue[2].value) + parseFloat(newValue[3].value))) /
  //       2
  //     ) {
  //       alert("2a号钢筋锚固长度不足， 请增大c的值或，同时增大c和R2的值");
  //     }
  //   }
  // );
  // 2和2a的间距和锚固长度检查~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  // Watch for 3
  watch([R, bar_3, cover_other], (newValue) => {
    bar_3.data.data_a.value =
      newValue[0].value * 1000 -
      newValue[2].value -
      newValue[1].diameter.value / 2;
  });

  // Watch for 4 => 锚栓内部是否布置
  // 监控r1 r2在合理的范围内
  watch(
    [bar_4.data.data_r1, bar_4.data.data_r2], (newValue) => {
      if (bar_4.data.data_set.value > 1) {  // >1 设置r1 时才判断

        if (newValue[0].value > R.value * 1000 - 100 || newValue[0].value <= R1.value * 1000) {
          Toast("内分段半径超出合理范围", 'no_04');
          bar_4.data.data_r1.value = R.value * 1000 - Math.floor(
            (R.value - R2.value) * 1000 * (bar_4.data.data_set.value - 1) / bar_4.data.data_set.value / 100
          ) * 100;
        }

        if (bar_4.data.data_set.value == 3) {   // =3 设置r2 时才判断
          if (newValue[1].value > R.value * 1000 - 100 || newValue[1].value <= bar_4.data.data_r1.value) {
            Toast("分段半径设置不合理", 'no_04');
            bar_4.data.data_r2.value = R.value * 1000 - (R.value * 1000 - bar_4.data.data_r1.value) / 2;
          }
        }
      }
    });



  // Watch for 4a


  watch([R, bar_1a, bar_3, cover_other, bar_1c, bar_1b], (newValue) => {

    if (newValue[5].data.data_set.value == 1) {

      bar_1c.diameter.status = false;
      bar_1c.space.status = false;

      bar_1c.data.data_b.value = (function () {
        let b_value = bar_4.data.data_b.value;
        for (let i = 1; i <= bar_4.num.value; i++) {
          b_value += bar_4.space.value
          if (b_value >= R2.value * 1000) {
            return b_value
          }
        }
      })()

      let tem = newValue[0].value * 1000 - newValue[3].value - newValue[2].diameter.value -
        newValue[1].diameter.value - newValue[1].data.data_b.value + newValue[5].data.data_b.value;
      bar_1c.num.value = Math.floor(
        (tem - bar_1c.data.data_b.value - 100) / newValue[4].space.value
      ) + 1;

      bar_1c.data.data_a.value = newValue[4].data.data_b.value + newValue[4].space.value * (bar_1c.num.value - 1)
    } else {
      bar_1c.diameter.status = true;
      bar_1c.space.status = true;
      bar_1c.num.value = 0;
      bar_1c.data.data_a.value = 0;
      bar_1c.data.data_b.value = 0;

    }
  });


  // Watch for 5


  // Watch for 6
  watch([Br_in, bar_6.space], (newValue) => {
    let num = Math.floor((newValue[0].value - 150) / newValue[1].value);
    bar_6.data.data_a.value = (num * newValue[1].value + 50) * 2;
  });
  watch([bar_6.space, bar_6.data.data_a], (newValue) => {
    bar_6.num.value =
      (Math.floor((newValue[1].value / 2 - 50) / newValue[0].value) * 2 + 1) *
      2;
  });

  // Watch for 7 7a
  watch(
    [
      Br_in,
      Br_out,
      R2,
      bar_7.diameter,
      bar_7a.diameter,
      cover_other,
      bar_8.diameter,
      bar_12.diameter,
      bar_7.space,
      bar_7a.space,
      bar_7a.data.data_b,
    ],
    (newValue) => {
      let tem_a =
        newValue[0].value +
        newValue[1].value -
        (newValue[2].value * 1000 -
          newValue[5].value -
          newValue[6].value / 2 -
          newValue[7].value);
      bar_7.data.data_a.value =
        Math.round((tem_a + Math.max(23 * newValue[3].value, 400)) / 50) *
        50 *
        2;
      bar_7a.data.data_a.value =
        Math.round((tem_a + Math.max(23 * newValue[4].value, 400)) / 50) *
        50 *
        2;

      bar_7.num.value =
        (Math.round((tem_a - 200) / newValue[8].value) * 2 + 1) * 2;
      bar_7a.num.value =
        (Math.round((tem_a - 200) / newValue[9].value) * 2 + 1) *
        2 *
        newValue[10].value;
    }
  );

  watch([H1, H2, H3], (newValue) => {
    bar_7a.data.data_b.value =
      Math.round(newValue[0].value + newValue[1].value + newValue[2].value) - 1;
  });

  // Watch for 8
  watch(
    [
      Br_in,
      Br_out,
      R2,
      H1,
      H2,
      H3,
      cover_other,
      cover_btm,
      bar_1.diameter,
      bar_4.diameter,
      bar_6.diameter,
      bar_8.diameter,
      bar_14.diameter,
      bar_4.data.data_e,
      bar_12.diameter,
    ],
    (newValue) => {
      if (parseFloat(newValue[13].value) == 0) {
        bar_8.data.data_a.value =
          Math.round(
            ((H1.value + H2.value + H3.value) * 1000 -
              (newValue[7].value + newValue[8].value + newValue[10].value * 2) -
              (newValue[6].value + newValue[12].value) -
              newValue[11].value) /
            5
          ) * 5;
      } else {
        bar_8.data.data_a.value =
          Math.round(
            ((H1.value + H2.value + H3.value) * 1000 -
              (newValue[7].value +
                newValue[8].value +
                newValue[9].value +
                newValue[10].value * 2) -
              (newValue[6].value + newValue[12].value) -
              newValue[11].value) /
            5
          ) * 5;
      }
      bar_8.data.data_b.value =
        Math.round(
          ((newValue[2].value * 1000 -
            newValue[6].value -
            newValue[14].value -
            newValue[11].value / 2 -
            (newValue[0].value + newValue[1].value) * 0.5) *
            2) /
          5
        ) * 5;
    }
  );

  //define Watch function for 9, 10, 11
  function get_barData(newValue, bar) {
    bar.data.data_a.value =
      Math.round(
        (newValue[1].value + newValue[0].value + newValue[2].value) / 5
      ) * 5;
    bar.data.data_b.value = Math.round((11 * newValue[2].value) / 5) * 5;
  }
  function get_barNum(newValue, bar) {
    bar.num.value = newValue[0].value * newValue[1].value;
  }
  // Watch for 9
  watch([bar_8.diameter, bar_8.data.data_b, bar_9.diameter], (newValue) =>
    get_barData(newValue, bar_9)
  );
  watch([Bnum_in, bar_9.data.data_c], (newValue) =>
    get_barNum(newValue, bar_9)
  );
  // Watch for 10
  watch([bar_8.diameter, bar_8.data.data_b, bar_10.diameter], (newValue) =>
    get_barData(newValue, bar_10)
  );
  watch([Bnum_in, bar_10.data.data_c], (newValue) =>
    get_barNum(newValue, bar_10)
  );
  // Watch for 11
  watch([bar_8.diameter, bar_8.data.data_b, bar_11.diameter], (newValue) =>
    get_barData(newValue, bar_11)
  );
  watch([Bnum_in, bar_11.data.data_c], (newValue) =>
    get_barNum(newValue, bar_11)
  );

  // Watch for 12
  watch([R2, cover_other, bar_12.diameter], (newValue) => {
    bar_12.data.data_a.value =
      newValue[0].value * 1000 - newValue[1].value - newValue[2].value / 2;
  });

  // Watch for 13
  watch([bar_12, bar_8, bar_13.diameter], (newValue) => {
    bar_13.data.data_a.value = Math.round(
      newValue[0].data.data_a.value -
      newValue[0].diameter.value / 2 -
      (newValue[1].data.data_b.value + newValue[1].diameter.value) -
      newValue[2].value / 2
    );
  });

  // Watch for 14
  watch(
    [
      Br_in,
      Br_out,
      bar_14.space,
      bar_8.data.data_b,
      bar_9.data.data_c,
      bar_10.data.data_c,
    ],
    (newValue) => {
      let num;
      if (
        (newValue[3].value / 2 -
          (newValue[1].value - newValue[0].value) / 2 -
          100) %
        newValue[2].value ==
        0
      ) {
        num =
          (newValue[3].value / 2 -
            (newValue[1].value - newValue[0].value) / 2 -
            100) /
          newValue[2].value -
          1;
      } else {
        num = Math.floor(
          (newValue[3].value / 2 -
            (newValue[1].value - newValue[0].value) / 2 -
            100) /
          newValue[2].value
        );
      }

      bar_14.data.data_b.value = Math.ceil((newValue[1].value + 100) / 10) * 10;
      bar_14.data.data_c.value =
        Math.floor((newValue[0].value - 100) / 10) * 10;
      bar_14.data.data_a.value =
        bar_14.data.data_b.value + num * newValue[2].value;
      bar_14.data.data_d.value =
        bar_14.data.data_c.value - num * newValue[2].value;
      bar_14.num.value =
        (num + 1) * 2 * (newValue[4].value + newValue[5].value + 2);
    }
  );

  // Watch for 15
  watch(
    [
      bar_15.data.data_set,
      bar_1.num,
      bar_1a.num,
      R,
      H1,
    ],
    (newValue) => {
      if (newValue[0].value == 0) {
        bar_15.diameter.status = bar_15.data.data_a.status = bar_15.data.data_b.status = true;
        bar_15.data.data_a.value = bar_15.data.data_b.value = 0;
      } else {
        bar_15.diameter.status = bar_15.data.data_a.status = bar_15.data.data_b.status = false;
        bar_15.data.data_a.value = Math.ceil(newValue[4].value * 1000 / 2 / 100) * 100 + 100;

        bar_15.data.data_b.value = Math.ceil(
          (newValue[3].value * 1000 - (newValue[1].value + newValue[2].value + bar_15.num.value) * (100) / (2 * Math.PI)) / 100
        ) * 100;
      }
    }
  );


  // Watch for 15a
  watch(
    [
      H1,
      cover_btm,
      bar_1.diameter,
      bar_1.data,
      bar_15a.diameter,
      R, // 5
      R1,
      H2,
      bar_2.diameter,
      bar_3.diameter,
      bar_5.diameter,
      cover_other,
      Bnum_in, //12
      bar_15a.data.data_set,
    ],
    (newValue) => {
      if (newValue[13].value == 0) {
        bar_15a.diameter.status = bar_15a.data.data_a.status = bar_15a.data.data_b.status = true;
        bar_15a.data.data_a.value =
          bar_15a.data.data_b.value = 0;
      } else {
        bar_15a.diameter.status = bar_15a.data.data_a.status = bar_15a.data.data_b.status = false;
        let param = getAngle(
          newValue[5],
          newValue[6],
          newValue[7],
          newValue[8],
          newValue[9],
          newValue[10],
          newValue[11]
        );
        let sita = param[4];

        bar_15a.data.data_a.value = Math.ceil(newValue[0].value * 1000 / 2 / 100) * 100 + 100;

        let temp_b =
          Math.ceil(
            (newValue[5].value * 1000 -
              (newValue[12].value * 2 * 200) / (2 * Math.PI)) /
            100
          ) * 100;
        bar_15a.data.data_b.value =
          Math.ceil(
            temp_b / Math.cos(sita - Math.PI / 2) / 10
          ) * 10;

      }
    }
  );

  function calHeight(
    set,
    H1,
    H2,
    R,
    R1,
    cover_other,
    cover_btm,
    bar_1d,
    bar_2d,
    bar_4d,
    bar_5d,
    r,
    c,
    diameter
  ) {
    let sita = Math.atan(H2.value / (R.value - R1.value));
    if (parseFloat(set.value) == 1) {
      return (
        H1.value * 1000 +
        (R.value * 1000 - r.value) * Math.tan(sita) -
        cover_btm.value -
        bar_1d.value -
        bar_4d.value -
        Math.cos(sita) * (cover_other.value + bar_2d.value + bar_5d.value) -
        diameter.value
      );
    } else {
      let height =
        H1.value * 1000 +
        (R.value * 1000 - r.value) * Math.tan(sita) -
        cover_btm.value -
        bar_1d.value -
        bar_4d.value -
        Math.cos(sita) * (cover_other.value + bar_5d.value) -
        diameter.value;
      return [
        height - (Math.sin(sita) * c.value) / 2,
        height + (Math.sin(sita) * c.value) / 2,
      ];
    }
  }

  // Watch for 16
  watch(
    [
      bar_16.data.data_set,
      H1,
      H2,
      R,
      R1,
      cover_other,
      cover_btm,
      bar_1.diameter,
      bar_2.diameter,
      bar_4.diameter,
      bar_5.diameter,
      bar_16.data.data_r,
      bar_16.data.data_c,
      bar_16.diameter,
    ],
    (newValue) => {
      if (
        R.value * 1000 > parseFloat(bar_16.data.data_r.value) && parseFloat(bar_16.data.data_r.value) > (R1.value * 1000)
      ) {
        let height = calHeight(
          newValue[0],
          newValue[1],
          newValue[2],
          newValue[3],
          newValue[4],
          newValue[5],
          newValue[6],
          newValue[7],
          newValue[8],
          newValue[9],
          newValue[10],
          newValue[11],
          newValue[12],
          newValue[13]
        );
        if (parseFloat(newValue[0].value) == 1) {
          bar_16.data.data_b.value = bar_16.data.data_d.value = Math.ceil(height);
        } else {
          bar_16.data.data_b.value = Math.ceil(height[0]);
          bar_16.data.data_d.value = Math.ceil(height[1]);
        }
      } else {
        Toast("定位半径应：大于R2，小于R，已自动调整", 'container-display', 55);
        bar_16.data.data_r.value = R1.value * 1000 + (R.value * 1000 - R1.value * 1000) / 3;
      }
    }
  );

  // Watch for 17
  watch(
    [
      bar_16.data.data_set,
      H1,
      H2,
      R,
      R1,
      cover_other,
      cover_btm,
      bar_1.diameter,
      bar_2.diameter,
      bar_4.diameter,
      bar_5.diameter,
      bar_17.data.data_r,
      bar_17.data.data_c,
      bar_17.diameter,
    ],
    (newValue) => {
      if (
        parseFloat(bar_17.data.data_r.value) > parseFloat(bar_16.data.data_r.value) && parseFloat(bar_17.data.data_r.value) < (R.value * 1000)
      ) {
        let height = calHeight(
          newValue[0],
          newValue[1],
          newValue[2],
          newValue[3],
          newValue[4],
          newValue[5],
          newValue[6],
          newValue[7],
          newValue[8],
          newValue[9],
          newValue[10],
          newValue[11],
          newValue[12],
          newValue[13]
        );
        if (parseFloat(newValue[0].value) == 1) {
          bar_17.data.data_b.value = bar_17.data.data_d.value =
            Math.ceil(height);
        } else {
          bar_17.data.data_b.value = Math.ceil(height[0]);
          bar_17.data.data_d.value = Math.ceil(height[1]);
        }
      } else {
        Toast("定位半径应：大于16号筋，小于R，已自动调整", 'container-display', 55);
        bar_17.data.data_r.value = bar_16.data.data_r.value + (R.value * 1000 - bar_16.data.data_r.value) / 2;
      }
    }
  );

  // Watch for 18
  watch([bar_18.data.data_set], (newValue) => {
    if (
      newValue[0].value == 0) {
      bar_18.num.status = true;
      bar_18.num.value = 0;
      bar_18.data.data_r.status = true;
      bar_18.data.data_r.value = "—";
      bar_18.data.data_a.status = bar_18.data.data_b.status = bar_18.data.data_c.status = bar_18.data.data_d.status = true;
      bar_18.data.data_a.value = bar_18.data.data_b.value = bar_18.data.data_c.value = bar_18.data.data_d.value = "—";


    } else {
      bar_18.num.status = false;
      bar_18.num.value = bar_17.num.value;
      bar_18.data.data_r.status = false;
      bar_18.data.data_r.value = bar_17.data.data_r.value + 1000;
      bar_18.data.data_c.status = false;
      bar_18.data.data_a.status = false;
      bar_18.data.data_a.value = 300;
      bar_18.data.data_c.value = 400;

    }
  });
  watch(
    [
      bar_16.data.data_set,
      H1,
      H2,
      R,
      R1,
      cover_other,
      cover_btm,
      bar_1.diameter,
      bar_2.diameter,
      bar_4.diameter,
      bar_5.diameter,
      bar_18.data.data_r, //11
      bar_18.data.data_c,
      bar_18.diameter,
      bar_17.data.data_r,
    ],
    (newValue) => {
      if (bar_18.data.data_set.value == 1) {
        if (
          parseFloat(bar_18.data.data_r.value) > parseFloat(bar_17.data.data_r.value) && parseFloat(bar_18.data.data_r.value) < (R.value * 1000)
        ) {
          let height = calHeight(
            newValue[0],
            newValue[1],
            newValue[2],
            newValue[3],
            newValue[4],
            newValue[5],
            newValue[6],
            newValue[7],
            newValue[8],
            newValue[9],
            newValue[10],
            newValue[11],
            newValue[12],
            newValue[13]
          );
          if (parseFloat(newValue[0].value) == 1) {
            bar_18.data.data_b.value = bar_18.data.data_d.value =
              Math.ceil(height);
          } else {
            bar_18.data.data_b.value = Math.ceil(height[0]);
            bar_18.data.data_d.value = Math.ceil(height[1]);
          }
        } else {
          Toast("定位半径应：大于17号筋，小于R，已自动调整", 'container-display', 55);
          bar_18.data.data_r.value = bar_17.data.data_r.value + (R.value * 1000 - bar_17.data.data_r.value) / 2;
        }
      }
    }
  );
  // ~~~~~~~~~~ Add more watchers here ~~~~~~~~~~
}
